module.exports = __webpack_public_path__ + "img/PPP Cement.6e97dab8.png";